'use client';

import { LINK } from '@constants';
import { HeaderLogo, NewYearLogo } from '@viewup/ui';
import { useEventStore } from 'app/_event';
import { useRouter } from 'next/navigation';

export const EventLogoSlot = () => {
  const router = useRouter();
  const isNewYear = useEventStore((s) => s.activeEvent === 'new-year-logo');
  const Logo = isNewYear ? NewYearLogo : HeaderLogo;
  return <Logo onClick={() => router.push(LINK.HOME)} style={{ cursor: 'pointer' }} />;
};
